module.exports = __webpack_public_path__ + "static/media/ok.ca5ededf.gif";